import Planner from '../../../components/pages/Planner';

export default Planner;

// eslint-disable-next-line @typescript-eslint/require-await
export const getServerSideProps = async () => ({ props: {} });
